import * as React from 'react'
import DataViews from "../views/bo-core/DataViewConfiguration";
import GlobalSearch from '../views/bo-core/GlobalSearch';
import {Route, Router, Switch} from 'react-router';
import {AuthRoute} from "./AuthRoute";
import history from '../config/history';
import Main from '../components/layouts/Main';
import Login from '../components/Login/Login';
import UserActivation from '../components/UserActivation/UserActivation';
import BusinessObjects from '../views/bo-core/BusinessObjects';
import ManageData from '../views/bo-core/ManageData';
import Accordeon from "../views/bo-core/Accordeon";
import TagManagementGrid from "../views/bo-core/TagManagementGrid";
import BulkUpdateInstances from "../components/bo-core/BulkUpdateInstances";
import AuditLog from "../views/bo-core/AuditLog";
import Status from "../views/bo-core/Status"
import RuleEngineRule from "../views/bo-core/RuleEngineRule";
import Users from "../views/bo-core/Users";
import Functionalities from "../views/bo-core/Functionalities";
import Roles from "../views/bo-core/Roles";
import Groups from "../views/bo-core/Groups";
import RuleEngineAction from "../views/bo-core/RuleEngineAction";
import Welcome from "../views/bo-core/welcome/Welcome";
import ForbiddenPage from "../views/bo-core/forbidden/ForbiddenPage";
import NotFoundPage from "../views/bo-core/notFound/NotFoundPage";
import RegisterUser from  '../views/bo-core/registerUser/RegisterUser'
import ForgotPassword from "../views/bo-core/forgotPassword/ForgotPassword";
import UsersManagement from "../views/bo-core/UsersManagement";
import TenantManagement from "../views/bo-core/TenantManagemet";

export enum Routes {
    ALL_ROUTES = '/*',
    BASE_PATH = '/',
    DATA_VIEW_CONFIG = '/dataviewconfiguration',  // mta only
    BUSINESS_OBJECTS = '/businessobjects', // mta only
    GLOBAL_SEARCH = '/globalsearch',
    MANAGE_DATA = '/managedata',
    ACCORDEON = '/instance/:id',
    BULK_UPDATE = '/bulk-update',
    TAG_MANAGEMENT = '/tagmanagement',
    AUDIT_LOG = '/audit-log',
    STATUS = '/status',
    RULE_ENGINE_RULE = '/rules/:id',
    RULE_ENGINE_ACTION = '/actions/:id',
    FUNCTIONALITIES = '/functionalities',
    ROLES = '/roles',
    USERS = '/users',
    GROUPS = '/groups',
    USER_MANAGEMENT = '/usermanagement', // sys admin only
    TENANT_MANAGEMENT = '/tenantmanagement', // mta only
    RULE_ENGINE_RULES = '/managedata?boc=sys rule engine rules',
    RULE_ENGINE_ACTIONS = '/managedata?boc=sys rule engine actions',
}

export enum PublicRoutes {
    LOGIN = '/login',
    REGISTER = '/register',
    FORGOT_PASS = '/forgot-password',
    USER_ACTIVATE = '/user/activate',
}

export enum StaticRoutes {
    FORBIDDEN = '/forbidden',
    WELCOME = '/welcome',
    NOT_FOUND = '/notfound'
}

const uiRoutes = () => {
    return <Router history={history}>
        <Main>
            <Switch>
                <AuthRoute
                    exact={true}
                    Component={GlobalSearch} path={`${process.env.ENV_PREFIX}${Routes.BASE_PATH}`}
                    uiRoute={Routes.BASE_PATH}
                />
                <AuthRoute
                    Component={GlobalSearch} path={`${process.env.ENV_PREFIX}${Routes.GLOBAL_SEARCH}`}
                    uiRoute={Routes.GLOBAL_SEARCH}
                />
                <AuthRoute
                    Component={DataViews} path={`${process.env.ENV_PREFIX}${Routes.DATA_VIEW_CONFIG}`}
                    uiRoute={Routes.DATA_VIEW_CONFIG}
                />
                <AuthRoute
                    Component={BusinessObjects} path={`${process.env.ENV_PREFIX}${Routes.BUSINESS_OBJECTS}`}
                    uiRoute={Routes.BUSINESS_OBJECTS}
                />
                <AuthRoute
                    Component={ManageData} path={`${process.env.ENV_PREFIX}${Routes.MANAGE_DATA}`}
                    uiRoute={Routes.MANAGE_DATA}
                />
                <AuthRoute
                    Component={Accordeon} path={`${process.env.ENV_PREFIX}${Routes.ACCORDEON}`}
                    uiRoute={Routes.ACCORDEON}
                />
                <AuthRoute
                    Component={BulkUpdateInstances} path={`${process.env.ENV_PREFIX}${Routes.BULK_UPDATE}`}
                    uiRoute={Routes.BULK_UPDATE}
                />
                <AuthRoute
                    Component={TagManagementGrid} path={`${process.env.ENV_PREFIX}${Routes.TAG_MANAGEMENT}`}
                    uiRoute={Routes.TAG_MANAGEMENT}
                />
                <AuthRoute
                    Component={AuditLog} path={`${process.env.ENV_PREFIX}${Routes.AUDIT_LOG}`}
                    uiRoute={Routes.AUDIT_LOG}
                />
                <AuthRoute
                    Component={Status} path={`${process.env.ENV_PREFIX}${Routes.STATUS}`}
                    uiRoute={Routes.STATUS}
                />
                <AuthRoute
                    Component={RuleEngineRule} path={`${process.env.ENV_PREFIX}${Routes.RULE_ENGINE_RULE}`}
                    uiRoute={Routes.RULE_ENGINE_RULE}
                />
                <AuthRoute
                    Component={RuleEngineAction} path={`${process.env.ENV_PREFIX}${Routes.RULE_ENGINE_ACTION}`}
                    uiRoute={Routes.RULE_ENGINE_ACTION}
                />
                <AuthRoute
                    Component={Functionalities} path={`${process.env.ENV_PREFIX}${Routes.FUNCTIONALITIES}`}
                    uiRoute={Routes.FUNCTIONALITIES}
                />
                <AuthRoute
                    Component={Roles} path={`${process.env.ENV_PREFIX}${Routes.ROLES}`}
                    uiRoute={Routes.ROLES}
                />
                <AuthRoute
                    Component={Users} path={`${process.env.ENV_PREFIX}${Routes.USERS}`}
                    uiRoute={Routes.USERS}
                />
                <AuthRoute
                    Component={Groups} path={`${process.env.ENV_PREFIX}${Routes.GROUPS}`}
                    uiRoute={Routes.GROUPS}
                />
                <AuthRoute
                    Component={UsersManagement} path={`${process.env.ENV_PREFIX}${Routes.USER_MANAGEMENT}`}
                    uiRoute={Routes.USER_MANAGEMENT}
                />
                <AuthRoute
                    Component={TenantManagement} path={`${process.env.ENV_PREFIX}${Routes.TENANT_MANAGEMENT}`}
                    uiRoute={Routes.TENANT_MANAGEMENT}
                />
                <AuthRoute
                    Component={ForbiddenPage} path={`${process.env.ENV_PREFIX}${StaticRoutes.FORBIDDEN}`}
                    uiRoute={StaticRoutes.FORBIDDEN}
                />
                <AuthRoute
                    Component={Welcome} path={`${process.env.ENV_PREFIX}${StaticRoutes.WELCOME}`}
                    uiRoute={StaticRoutes.WELCOME}
                />
                <Route component={NotFoundPage}/>
            </Switch>
        </Main>
        <Route path={`${process.env.ENV_PREFIX}${PublicRoutes.LOGIN}`} component={Login}/>
        <Route path={`${process.env.ENV_PREFIX}${PublicRoutes.REGISTER}`} component={RegisterUser}/>
        <Route path={`${process.env.ENV_PREFIX}${PublicRoutes.FORGOT_PASS}`} component={ForgotPassword}/>
        <Route path={`${process.env.ENV_PREFIX}${PublicRoutes.USER_ACTIVATE}`} component={UserActivation}/>
    </Router>
};

export default uiRoutes



// WEBPACK FOOTER //
// ./app/config/routes.tsx